import { Component, Input } from '@angular/core'
import { CartItemComponent } from '@spartacus/cart/base/components'
import { ICustomOrderEntry } from '../../../../../../models/interface/order-entry.interface'

@Component({
    selector: 'app-dispenser-order-items',
    templateUrl: './dispenser-order-items.component.html',
    styleUrls: ['./dispenser-order-items.component.scss'],
    standalone: false
})
export class DispenserOrderItemsComponent extends CartItemComponent {
  @Input() customItem: ICustomOrderEntry
}
